/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateTermDto } from '../models/CreateTermDto';
import type { TermDto } from '../models/TermDto';
import type { ScheduleDateRangeDto } from '../models/ScheduleDateRangeDto';
import type { UpdateExpectedOpponentsDto } from '../models/UpdateExpectedOpponentsDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class TermControllerService {
    /**
     * @param id
     * @param requestBody
     * @returns TermDto OK
     * @throws ApiError
     */
    /**
     * @param id
     * @param requestBody
     * @returns TermDto OK
     * @throws ApiError
     */
    public static updateDateRange(
        id: number,
        requestBody: {
            startDate: string;
            endDate: string;
        },
    ): CancelablePromise<TermDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/terms/{id}/date-range',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    public static updateExpectedOpponents(
        id: number,
        requestBody: UpdateExpectedOpponentsDto,
    ): CancelablePromise<TermDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/terms/{id}/expected-opponents',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns TermDto Created
     * @throws ApiError
     */
    public static createTerm(
        requestBody: CreateTermDto,
    ): CancelablePromise<TermDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/terms',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns TermDto Created
     * @throws ApiError
     */
    public static createBatch(
        requestBody: Array<CreateTermDto>,
    ): CancelablePromise<Array<TermDto>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/terms/batch',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param teamId
     * @returns ScheduleDateRangeDto OK
     * @throws ApiError
     */
    public static getAllDatesForSchedule(
        teamId: number,
    ): CancelablePromise<Array<ScheduleDateRangeDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/terms/dates/by-team/{teamId}',
            path: {
                'teamId': teamId,
            },
        });
    }
    /**
     * @param teamId
     * @returns TermDto OK
     * @throws ApiError
     */
    public static getByTeamId(
        teamId: number,
    ): CancelablePromise<Array<TermDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/terms/by-team/{teamId}',
            path: {
                'teamId': teamId,
            },
        });
    }
    /**
     * @param preseasonGameId
     * @returns TermDto OK
     * @throws ApiError
     */
    public static getByPreseasonGameId(
        preseasonGameId: number,
    ): CancelablePromise<Array<TermDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/terms/by-preseason-game/{preseasonGameId}',
            path: {
                'preseasonGameId': preseasonGameId,
            },
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static updateCampInfo(
        id: number,
        requestBody: {
            isAtCamp?: boolean;
            campLatitude?: number;
            campLongitude?: number;
            campAddress?: string;
            campMaxDistanceKm?: number;
        },
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/terms/{id}/camp',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @returns void
     * @throws ApiError
     */
    public static deleteTerm(
        id: number,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/terms/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param id
     * @returns void
     * @throws ApiError
     */
    public static incrementAmountOfGames(
        id: number,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/terms/{id}/increment-games',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param id
     * @returns void
     * @throws ApiError
     */
    public static decrementAmountOfGames(
        id: number,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/terms/{id}/decrement-games',
            path: {
                'id': id,
            },
        });
    }
}
